export default __webpack_public_path__ + "static/media/seam-icon.1a0a08da.png";